import { findIndex } from 'lodash'
import * as PickstarUserAnalytics from '@pickstar/user-analytics'

export default {
  computed: {
    analytics () {
      return PickstarUserAnalytics
    }
  },
  methods: {
    trackEvent (Event, additionalParams = {}) {
      const trackingEvent = new Event()
      const params = Object.keys(trackingEvent)
      params.forEach(param => {
        if (param in additionalParams) {
          trackingEvent[param] = additionalParams[param]
        } else if (this.resolveParam(param)) {
          trackingEvent[param] = this.resolveParam(param)
        }
      })
      if (this.$analytics) {
        this.$analytics.track(trackingEvent)
      }
    },
    resolveParam (param) {
      switch (param) {
        case 'jobId':
          return this.thread && this.thread.booking && this.thread.booking.id ? this.thread.booking.id : null
        case 'jobStatus':
          return this.booking && this.booking.status ? this.booking.status : null
        case 'jobChatType':
        case 'chatType':
          return this.getChatType()
      }
    },
    getChatType () {
      let clientInvolved = false
      let managerInvolved = false
      let talentInvolved = false
      if (this.thread && this.thread.participants) {
        clientInvolved = findIndex(this.thread.participants, participant => participant.role.toLowerCase() === 'client') !== -1
        managerInvolved = findIndex(this.thread.participants, participant => participant.role.toLowerCase() === 'manager') !== -1
        talentInvolved = findIndex(this.thread.participants, participant => participant.role.toLowerCase() === 'talent') !== -1
      }

      if (clientInvolved && managerInvolved && talentInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_TALENT_CLIENT
      if (clientInvolved && talentInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_TALENT_CLIENT
      if (managerInvolved && talentInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_TALENT_MANAGER
      if (clientInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_CLIENT
      if (managerInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_MANAGER
      if (talentInvolved) return PickstarUserAnalytics.V2.ChatType.ADMIN_TALENT
      return false
    }
  }
}
